"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncateToFirstName = exports.truncateEmail = exports.truncateDisplayName = exports.determineQuestionCountString = exports.toMMDDYYYY = exports.toMMDD = exports.getAppLogoFromMimeType = exports.getSyncProgressCSSBackgroundColor = exports.getSyncProgressAsLabel = exports.acceptableResourceMimeType = exports.makeUrlFromGoogleFile = exports.dedupeStringArray = exports.getVisibleAppsFromLinkRecords = exports.extractUrlsFromText = exports.getLinkRecordsFromUrlList = exports.getLinkRecordsByTag = exports.getLinkRecordsByApp = exports.getLinkRecordsByUser = exports.getLinkRecordIdsFromContext = exports.getCompressedAppMenuPath = exports.getDomainFromHostname = exports.getStoreLinkRecord = exports.sortAndPrioritizeTags = exports.getDefaultUserAvatar = exports.iconPath = exports.colorWheel = void 0;
const contracts_1 = require("./contracts");
const linkHelpers_1 = require("./linkHelpers");
const colorWheel = (i) => {
    const colors = [
        "#15A5F6",
        "#00fa19",
        "#fc0e0e",
        "#e0ff3a",
        "#9111b8",
        "#563b26",
        "#cd8440",
    ];
    const index = i % 7;
    return colors[index];
};
exports.colorWheel = colorWheel;
const iconPath = (file, user) => {
    return (0, linkHelpers_1.getIconPath)(file, {
        theme: (user === null || user === void 0 ? void 0 : user.theme) || "light-mode",
        isAppLogo: false,
    });
};
exports.iconPath = iconPath;
const getDefaultUserAvatar = (name, url = "") => {
    if (!name) {
        return `${url}/avatar_unknown.png`;
    }
    return `${url}/icons/avatars/${name.trim().substring(0, 1).toUpperCase()}.png`;
};
exports.getDefaultUserAvatar = getDefaultUserAvatar;
const sortAndPrioritizeTags = (tags, prioritizeId) => {
    const newTags = new Array(...tags);
    newTags.sort((a, b) => {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
    });
    const pIndex = newTags.findIndex((tag) => {
        return tag.id === prioritizeId;
    });
    if (pIndex === -1 || pIndex === 0) {
        return newTags;
    }
    const priorityTag = Object.assign({}, newTags[pIndex]);
    newTags.splice(pIndex, 1);
    newTags.unshift(priorityTag);
    return newTags;
};
exports.sortAndPrioritizeTags = sortAndPrioritizeTags;
const getStoreLinkRecord = (linkRecordId, linkRecords) => {
    const lrIndex = linkRecords.findIndex((linkRecord) => {
        return linkRecord.id === linkRecordId;
    });
    return lrIndex !== -1 ? linkRecords[lrIndex] : null;
};
exports.getStoreLinkRecord = getStoreLinkRecord;
const getDomainFromHostname = (hostname) => {
    try {
        return hostname.split(".").reverse().splice(0, 2).reverse().join(".");
    }
    catch (err) {
        return hostname;
    }
};
exports.getDomainFromHostname = getDomainFromHostname;
const getCompressedAppMenuPath = (id, pathRoot, storeUser) => {
    return (0, linkHelpers_1.getIconPath)(`${pathRoot}-activity.svg`, {
        theme: (storeUser === null || storeUser === void 0 ? void 0 : storeUser.theme) || "light-mode",
        isActivity: true,
        isAppLogo: true,
    });
};
exports.getCompressedAppMenuPath = getCompressedAppMenuPath;
const getLinkRecordIdsFromContext = (aiContext, linkRecords) => {
    if (!linkRecords) {
        return [];
    }
    const linkRecordIds = [];
    if (aiContext.linkRecordId) {
        linkRecordIds.push(aiContext.linkRecordId);
    }
    // remove dupes by using a Map key set
    const idMap = new Map();
    linkRecordIds.forEach((id) => {
        idMap.set(id, true);
    });
    const finalIds = Array.from(idMap.keys());
    return finalIds;
};
exports.getLinkRecordIdsFromContext = getLinkRecordIdsFromContext;
const getLinkRecordsByUser = (userId, linkRecords) => {
    return linkRecords.filter((linkRecord) => {
        return linkRecord.userId === userId;
    });
};
exports.getLinkRecordsByUser = getLinkRecordsByUser;
const getLinkRecordsByApp = (appId, linkRecords) => {
    return linkRecords.filter((linkRecord) => {
        if (linkRecord.links && linkRecord.links.length > 0) {
            return linkRecord.links[0].appId === appId;
        }
        return false;
    });
};
exports.getLinkRecordsByApp = getLinkRecordsByApp;
const getLinkRecordsByTag = (tagId, linkRecords) => {
    return linkRecords.filter((linkRecord) => {
        if (linkRecord.tags && linkRecord.tags.length > 0) {
            const index = linkRecord.tags.findIndex((tag) => {
                return tag.id === tagId;
            });
            return index !== -1;
        }
        return false;
    });
};
exports.getLinkRecordsByTag = getLinkRecordsByTag;
// take list of urls, return deduped list of link records
const getLinkRecordsFromUrlList = (urls, linkRecords, supportedApps) => {
    if (!supportedApps || !linkRecords) {
        return [];
    }
    const finalLinkRecords = [];
    const lrMap = new Map();
    urls.forEach((url) => {
        const linkAppConfig = (0, linkHelpers_1.findLinkAppConfig)(url, supportedApps);
        if (linkAppConfig) {
            const externalId = (0, linkHelpers_1.parseExternalId)(url, linkAppConfig);
            const index = linkRecords.findIndex((linkRecord) => {
                const link = linkRecord.links ? linkRecord.links[0] : null;
                if (link &&
                    link.appId === linkAppConfig.id &&
                    link.externalId === externalId) {
                    if (!lrMap.has(linkRecord.id)) {
                        lrMap.set(linkRecord.id, true);
                        finalLinkRecords.push(linkRecord);
                    }
                }
            });
        }
    });
    return finalLinkRecords;
};
exports.getLinkRecordsFromUrlList = getLinkRecordsFromUrlList;
const extractUrlsFromText = (text) => {
    // console.log("[extractUrls] extracted urls from: ", text);
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.match(urlRegex);
};
exports.extractUrlsFromText = extractUrlsFromText;
const getVisibleAppsFromLinkRecords = (linkRecords, supportedApps) => {
    if (!linkRecords || !supportedApps) {
        return [];
    }
    const appMap = new Map();
    linkRecords.forEach((linkRecord) => {
        const link = linkRecord.links ? linkRecord.links[0] : null;
        if (link && link.appId) {
            if (!appMap.has(link.appId)) {
                appMap.set(link.appId, true);
            }
        }
    });
    const linkAppConfigs = [];
    Array.from(appMap.keys()).forEach((appId) => {
        const linkAppConfig = (0, linkHelpers_1.findAppConfigById)(appId, supportedApps);
        if (linkAppConfig) {
            linkAppConfigs.push(linkAppConfig);
        }
    });
    return linkAppConfigs;
};
exports.getVisibleAppsFromLinkRecords = getVisibleAppsFromLinkRecords;
const dedupeStringArray = (source) => {
    const arrayMap = new Map();
    source.forEach((item) => {
        if (!arrayMap.has(item)) {
            arrayMap.set(item, true);
        }
    });
    return Array.from(arrayMap.keys());
};
exports.dedupeStringArray = dedupeStringArray;
const makeUrlFromGoogleFile = (fileId, mimeType) => {
    let url = "";
    switch (mimeType) {
        case "application/vnd.google-apps.document":
            url = `https://docs.google.com/document/d/${fileId}`;
            break;
        case "application/vnd.google-apps.spreadsheet":
            url = `https://docs.google.com/spreadsheets/d/${fileId}`;
            break;
        case "application/vnd.google-apps.presentation":
            url = `https://docs.google.com/presentation/d/${fileId}`;
            break;
        case "text/plain":
        case "application/pdf":
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        case "application/msword":
            url = `https://drive.google.com/file/d/${fileId}/view?usp=drive_link`;
            break;
        // case ""
        //   url = `https://drive.google.com/document/d/${fileId}/view?usp=drive_link`;
        //   break;
    }
    return url;
};
exports.makeUrlFromGoogleFile = makeUrlFromGoogleFile;
const acceptableResourceMimeType = (mimeType) => {
    if (!mimeType) {
        return false;
    }
    let acceptable = false;
    switch (mimeType) {
        case "application/vnd.google-apps.document":
        // case "application/vnd.google-apps.spreadsheet":
        // case "application/vnd.google-apps.presentation":
        case "text/plain":
        case "application/txt":
        case "application/pdf":
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document": // docx
        case "application/msword": // doc
        case "application/rdf":
        // case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        // case "application/vnd.ms-excel":
        case "ms/list-item": // aspx
            acceptable = true;
    }
    return acceptable;
};
exports.acceptableResourceMimeType = acceptableResourceMimeType;
const getSyncProgressAsLabel = (syncStatus) => {
    let status = "";
    switch (syncStatus) {
        case contracts_1.SyncProgress.ERRORED:
            status = "Errored";
            break;
        case contracts_1.SyncProgress.NOT_PROCESSING:
            status = "Not currently processing";
            break;
        case contracts_1.SyncProgress.PROCESSING:
            status = "Processing";
            break;
        case contracts_1.SyncProgress.UP_TO_DATE:
            status = "Up to date";
            break;
    }
    return status;
};
exports.getSyncProgressAsLabel = getSyncProgressAsLabel;
const getSyncProgressCSSBackgroundColor = (syncStatus) => {
    let color = "transparent";
    switch (syncStatus) {
        case contracts_1.SyncProgress.ERRORED:
            color = "var(--sync-color-error)";
            break;
        case contracts_1.SyncProgress.NOT_PROCESSING:
            color = "var(--sync-color-not-processing)";
            break;
        case contracts_1.SyncProgress.PROCESSING:
            color = "var(--sync-color-processing)";
            break;
        case contracts_1.SyncProgress.UP_TO_DATE:
            color = "var(--sync-color-up-to-date)";
            break;
    }
    return color;
};
exports.getSyncProgressCSSBackgroundColor = getSyncProgressCSSBackgroundColor;
const getAppLogoFromMimeType = (mimeType) => {
    console.log("[getAppLogoFromMimeType] mimeType", mimeType);
    const mapping = linkHelpers_1.MIME_TYPE_MAPPINGS[mimeType];
    if (mapping) {
        return mapping.icon;
    }
    return "other.svg";
};
exports.getAppLogoFromMimeType = getAppLogoFromMimeType;
function toMMDD(date) {
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}-${day}`;
}
exports.toMMDD = toMMDD;
function toMMDDYYYY(date) {
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
}
exports.toMMDDYYYY = toMMDDYYYY;
const determineQuestionCountString = (diff) => {
    if (diff === 1 || diff === 0) {
        return "You have no questions remaining.";
    }
    else if (diff === 6 || diff === 5 || diff === 4 || diff === 3) {
        return `You have ${diff - 1} questions remaining.`;
    }
    else if (diff === 2) {
        return "You have 1 question remaining.";
    }
    return "";
};
exports.determineQuestionCountString = determineQuestionCountString;
const truncateDisplayName = (name) => {
    const displayName = name.split(" ");
    return `${displayName[0]} ${displayName[1].substring(0, 1)}.`;
};
exports.truncateDisplayName = truncateDisplayName;
const truncateEmail = (email) => {
    if (email.length > 30) {
        return email.substring(0, 17) + "..." + email.substring(email.length - 12);
    }
    return email;
};
exports.truncateEmail = truncateEmail;
const truncateToFirstName = (name) => {
    const displayName = name.split(" ");
    return displayName[0];
};
exports.truncateToFirstName = truncateToFirstName;
